"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Icon_1 = __importDefault(require("../../../Icon/Icon"));
var Loader_1 = __importDefault(require("../../../Loader/Loader"));
var genIcon_1 = __importDefault(require("../../../../utils/genIcon"));
var react_1 = require("react");
/**
 * An Item can either be a node or a leaf.
 */
var Item = /** @class */ (function (_super) {
    __extends(Item, _super);
    function Item(props) {
        var _this = _super.call(this, props) || this;
        _this.genClasses = function () {
            var _a = _this.props, className = _a.className, active = _a.active, activeSubNav = _a.activeSubNav, children = _a.children;
            var classes = 'content';
            if (className) {
                classes += " " + className;
            }
            if (active) {
                classes += ' active';
            }
            if (activeSubNav) {
                classes += ' expanded';
            }
            if (!!React.Children.count(children)) {
                classes += ' has-children';
            }
            return classes;
        };
        _this.checkIsOpen = function () {
            var expanded = _this.props.expanded;
            return expanded === undefined ? _this.state.isOpen : expanded;
        };
        _this.clickEvents = function () {
            var _a = _this.props, children = _a.children, onClick = _a.onClick, forceParent = _a.forceParent;
            var hasChildren = !!React.Children.count(children);
            var isForcedOpened = hasChildren || forceParent;
            onClick && onClick();
            isForcedOpened && _this.setState({ isOpen: !_this.state.isOpen });
        };
        _this.state = {
            isOpen: false
        };
        return _this;
    }
    Item.prototype.render = function () {
        var _a = this.props, children = _a.children, title = _a.title, icon = _a.icon, iconRoot = _a.iconRoot, nestedDepth = _a.nestedDepth, className = _a.className, imageUrl = _a.imageUrl, active = _a.active, forceParent = _a.forceParent, actionRenderer = _a.actionRenderer, isLoading = _a.isLoading, expanded = _a.expanded, onClick = _a.onClick, onTitleClick = _a.onTitleClick, rest = __rest(_a, ["children", "title", "icon", "iconRoot", "nestedDepth", "className", "imageUrl", "active", "forceParent", "actionRenderer", "isLoading", "expanded", "onClick", "onTitleClick"]);
        var hasChildren = !!React.Children.count(children);
        var iconClassName = hasChildren || forceParent ? 'icon-child' : '';
        return (React.createElement("div", __assign({}, rest, { className: 'tree-item ' + (className || '') }),
            title &&
                React.createElement("div", { className: this.genClasses(), style: { paddingLeft: nestedDepth + ".75rem" } },
                    React.createElement("div", { className: 'left-content' },
                        this.renderListItemIcon(),
                        imageUrl && React.createElement("div", { className: 'item-image', style: { 'backgroundImage': "url(" + imageUrl + ")" } }),
                        icon && !imageUrl && genIcon_1.default(icon, { root: iconRoot, className: iconClassName }),
                        React.createElement("span", { onClick: function () { return onTitleClick && onTitleClick(); }, className: 'title' + (onTitleClick ? ' mouse-pointer' : '') }, title)),
                    actionRenderer &&
                        React.createElement("div", { className: 'right-content', onClick: function (e) { return e.stopPropagation(); } }, actionRenderer)),
            this.renderChildren(children)));
    };
    Item.prototype.renderChildren = function (children) {
        var isOpen = this.checkIsOpen();
        var _a = this.props, isLoading = _a.isLoading, forceParent = _a.forceParent, nestedDepth = _a.nestedDepth;
        var isForcedOpened = isLoading && isOpen || isOpen && forceParent;
        if (isForcedOpened) {
            var depthLoader = nestedDepth ? nestedDepth + 4 : 4;
            return (React.createElement("div", { className: "item-loader", style: { left: depthLoader + ".8rem" } },
                React.createElement(Loader_1.default, { minHeight: 20, text: " " })));
        }
        return (React.Children.map(children, function (content) {
            var depthCount = nestedDepth ? nestedDepth + 2 : 3;
            return (React.createElement("div", { className: isOpen ? "child-open" : 'child-close' }, React.cloneElement(content, __assign(__assign({}, content.props), { nestedDepth: depthCount }))));
        }));
    };
    Item.prototype.renderListItemIcon = function () {
        var _a = this.props, forceParent = _a.forceParent, icon = _a.icon, children = _a.children;
        var hasChildren = !!React.Children.count(children);
        var isOpen = this.checkIsOpen();
        var listItemIcon;
        if (forceParent || hasChildren) {
            listItemIcon = React.createElement("span", { className: "mouse-pointer caret", onClick: this.clickEvents },
                React.createElement(Icon_1.default, { root: "common", className: "tree-caret", name: isOpen ? 'caret-down' : 'caret-right' }));
        }
        else if (!icon) {
            listItemIcon = React.createElement("div", { className: "indent" });
        }
        return listItemIcon;
    };
    Item.defaultProps = {
        iconRoot: 'common'
    };
    return Item;
}(react_1.Component));
exports.default = Item;
